import { z } from "zod/v4";
import { TenantPathParams, defineResource, defineEndpoint } from "@visioni/a3s-client-api";
import { SiteIdCodec } from "@visioni/a3s-schema/codecs";
import { ProductInterest, UpsellRequest, UpsellStatus } from "../schema";

const FEATURE_NAME = "upsell";

export const upsellRequestResource = defineResource({
  feature: FEATURE_NAME,
  resource: "request",
  scope: "tenant",
});

export const upsellStatusResource = defineResource({
  feature: FEATURE_NAME,
  resource: "status",
  scope: "tenant",
});

export const submitUpsellRequestEndpoint = defineEndpoint(upsellRequestResource, {
  method: "POST",
  bodySchema: UpsellRequest,
  responseSchema: UpsellStatus,
});

/**
 * Flat query-string schema for `GET /upsell/status`. `siteId` is optional
 * at the HTTP layer so query-string parsing accepts any combination; the
 * get-status handler narrows the params using the
 * {@link UpsellStatusParams} discriminated union and returns 400 if a
 * required field for the requested product is missing.
 */
export const GetStatusQueryParams = z.object({
  product: ProductInterest,
  siteId: SiteIdCodec.optional(),
});

export type GetStatusQueryParams = z.output<typeof GetStatusQueryParams>;

export const getUpsellStatusEndpoint = defineEndpoint(upsellStatusResource, {
  responseSchema: UpsellStatus,
  querySchema: GetStatusQueryParams,
});

export const SubmitRequestPathParams = TenantPathParams;
export type SubmitRequestPathParams = z.output<typeof SubmitRequestPathParams>;

export const GetStatusPathParams = TenantPathParams;
export type GetStatusPathParams = z.output<typeof GetStatusPathParams>;
